// 1. Fix ResultsContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from './AuthContext';

import { createLogger } from '../utils/logger';

const logger = createLogger('ResultsContext');

const ResultsContext = createContext();

export const ResultsProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [hasResults, setHasResults] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkResults = async () => {
      if (!currentUser) {
        setHasResults(false);
        setLoading(false);
        return;
      }

      try {
        // Fixed: Reading from 'users' collection instead of 'quizResults'
        const docRef = doc(db, 'users', currentUser.uid);
        const resultSnap = await getDoc(docRef);

        // Check if quizResults exists in the user document
        setHasResults(resultSnap.exists() && resultSnap.data().quizResults);
      } catch (err) {
        logger.error('Error checking quiz results:', err);
        setHasResults(false);
      } finally {
        setLoading(false);
      }
    };

    checkResults();
  }, [currentUser]);

  return (
    <ResultsContext.Provider value={{ hasResults, loading }}>
      {children}
    </ResultsContext.Provider>
  );
};

export const useResults = () => useContext(ResultsContext);
